export const ADMIN_SHELL_BODY_CLASSES = Object.freeze({
  scroll: "sidebar-rail-app-shell-scroll",
  rail: "sidebar-rail",
  mini: "sidebar-mini",
  navHidden: "sidebar-rail-navigation-hidden",
});

export function clearAdminShellBodyClasses(
  body = typeof document !== "undefined" ? document.body : null
) {
  if (!body?.classList) return;

  body.classList.remove(
    ADMIN_SHELL_BODY_CLASSES.scroll,
    ADMIN_SHELL_BODY_CLASSES.rail,
    ADMIN_SHELL_BODY_CLASSES.mini,
    ADMIN_SHELL_BODY_CLASSES.navHidden
  );
}
